import { MenuItem } from '@material-ui/core';
import React from 'react';

import useCustomerSelectable from 'core/hooks/useCustomerSelectable';
import { InputField, InputFieldProps } from 'Elements/Form';

export default function CustomerSelect(props: InputFieldProps) {
  const customers = useCustomerSelectable();

  return (
    <InputField
      {...props}
      select
      fullWidth
      variant="outlined"
      placeholder="Valitse"
      margin="normal"
      InputLabelProps={{
        shrink: true
      }}
    >
      {customers
        .sort((a, b) => a.company.localeCompare(b.company))
        .map(customer => (
          <MenuItem key={customer.id} value={customer.id}>
            {customer.company}
          </MenuItem>
        ))}
    </InputField>
  );
}
